import { RobotsFormValidationSchema } from '../../../robots.interfaces';

export const robotsFormValidationSchema: RobotsFormValidationSchema = {
  content: [
    { required: false },
    { type: 'string', message: 'Назва має бути строкою' }
  ]
};
